import { TabsContentProfileProps } from "./TabsContentProfile.types";
import {
  ContentGoals,
  ContentExternalTraining,
  ContentSector,
  ContentKnowledge,
  ContentPreferences
} from "../../components";
import {
  TAB_ITEMS_PROFILE
} from "../../consts";

export function TabsContentProfile({
  tabTypeProfile,
  learnerAchievements
}: TabsContentProfileProps) {
  switch (tabTypeProfile) {
  case TAB_ITEMS_PROFILE.GOALS:
    return (
      <ContentGoals learnerAchievements={ learnerAchievements }
      />
    );
  case TAB_ITEMS_PROFILE.SECTOR:
    return (
      <ContentSector/>
    );

  case TAB_ITEMS_PROFILE.KNOWLEDGE:
    return (
      <ContentKnowledge/>
    );

  case TAB_ITEMS_PROFILE.PREFERENCES:
    return (
      <ContentPreferences/>
    );

  case TAB_ITEMS_PROFILE.EXTERNAL_TRAINING:
    return (
      <ContentExternalTraining/>
    );

  default:
    return (
      <></>
    );
  }
}
